/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Status/view.blocks to change it.
import * as fromData from 'Simple/Data'
import InfoTooltip from './InfoTooltip/index'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Status({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/EffectiveDate/Status",
  hovered,
  onMouseEnterManual,
  onMouseLeaveManual
  
}) {
let assignedInsuranceInsuranceSubscriptionActiveValueData = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.active',
})
let assignedInsuranceInsuranceSubscriptionActiveValueData1 = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.active',
})
  return (<React.Fragment
>
<div
  data-testid="Status.Vertical"
  data-view-path={viewPath}
 hovered={hovered}
 onMouseEnter={onMouseEnterManual}
 onMouseLeave={onMouseLeaveManual}
 className={`views-block ${styles.Vertical}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type={assignedInsuranceInsuranceSubscriptionActiveValueData ? "green" : "red"}
 data="assigned_insurance.insurance_subscription.active"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text={assignedInsuranceInsuranceSubscriptionActiveValueData1 ? "Active" : "Inactive"}
 data="assigned_insurance.insurance_subscription.active"
/>
)}
</TysiaTag>
<InfoTooltip
  viewPath={`${viewPath}/InfoTooltip`}
 flowNo={!hovered}
 flowContent={hovered}
/>
</div>
{children}
</React.Fragment>)
}